<template lang="pug">
    div.pt-5.text-center(v-if="loading")
      v-progress-circular(size="70" color="info" indeterminate)
    v-expansion-panels.mb-4(
      v-else-if="!loading && courses.length > 0"
      class="sdo-tree-view"
      accordion
      flat
    )
      v-expansion-panel(v-for="course in courses" :key="course.course_id")
        v-expansion-panel-header {{ course.title }}
        v-expansion-panel-content
          course-requests-table(:requests="course.requests" :key="course.course_id")
    div(v-else)
      p.text-subtitle-1 Нет входящих заявок.

</template>

<script>
import { mapGetters } from 'vuex';

import CourseRequestsTable from '@/modules/Courses/components/CourseRequestsTable.vue';

export default {
  name: 'CourseRequests',
  components: { CourseRequestsTable },
  data: () => ({
    loading: true,
    courses: [],
  }),
  computed: {
    ...mapGetters({ userData: 'auth/userData' }),
  },
  mounted() {
    this.init();
  },
  methods: {
    /**
     * Вызывается для получения списка своих заявок
     *
     */
    async getOwnCoursesRequestsList(params = {}) {
      params.expand = 'chat_room_id';
      const response = await this.$rHandler(
        this.$api.exchange.getOwnCoursesRequestsList(params),
        (r) => r.data.data,
      );
      return response;
    },
    /**
     * Вызывается для получения списка собственных курсов с биржи
     *
     * @param {Object} params - Объект с параметрами для GET-запроса
     */
    async getOwnSellingCoursesList(params = {}) {
      params['search[owner_id]'] = this.userData.id;
      const response = await this.$rHandler(
        this.$api.exchange.getOwnSellingCoursesList(params),
        (r) => r.data.data,
      );
      return response;
    },
    /**
     * Объединение полученных данных для создания массива курсов,
     * в котором каждый объект курса содержит массив заявок к нему
     *
     */
    async init() {
      const courses = await this.getOwnSellingCoursesList();
      const requests = await this.getOwnCoursesRequestsList();
      const coursesWithRequests = courses.map((course) => (
        {
          ...course,
          requests: requests.filter((req) => req.course_id === course.course_id),
        }
      ));
      this.courses = coursesWithRequests;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>

  .task-table {
    border-radius: 6px;
    box-shadow: 0 4px 15px -12px rgba(0, 0, 0, 0.8);
    //border: 1px solid #f2f2f2;
    position: relative;
    padding: 8px;

    &.theme--dark {
      background-color: $table-dark-bg;
    }

    &:before {
      content: "";
      position: absolute;
      top: -14px;
      left: -16px;
      width: 2px;
      height: calc(100% + 10px);
      background-color: #ddd;
      border-radius: 2px;
    }
  }

  .theme--dark.v-expansion-panels .v-expansion-panel {
    background: none;
  }

</style>
